import { useCallback, useMemo } from 'react';

import { useI18n } from '#/i18n/hooks/useI18n';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { LOCALE_NAMES } from '#/utils/constants/general/locales';
import { createCookie } from '#/utils/cookies';

import {
  PageFooterLocaleLinksDisabledText,
  PageFooterLocaleLinksLink,
} from './PageFooterLocaleLinksItem.styled';

type Props = {
  linkLocale: I18nLocale;
  localeUrl: string | undefined;
};

export function PageFooterLocaleLinksItem({ linkLocale, localeUrl }: Props) {
  const { i18n, locale } = useI18n();
  const select = useCallback(
    () => createCookie('_LOCALE_', linkLocale, 1825),
    [linkLocale],
  );

  const title = useMemo(() => {
    if (!localeUrl)
      return i18n('This page is currently not available in %(language)s', {
        language: LOCALE_NAMES[linkLocale],
      });

    return '';
  }, [i18n, localeUrl, linkLocale]);

  const isSelected = linkLocale !== locale;

  if (isSelected && localeUrl) {
    return (
      <PageFooterLocaleLinksLink
        href={localeUrl || ''}
        qaId={`locale-link-${linkLocale}`}
        onClick={select}
      >
        {LOCALE_NAMES[linkLocale]}
      </PageFooterLocaleLinksLink>
    );
  }

  return (
    <PageFooterLocaleLinksDisabledText
      data-qa-id={`disabled-locale-link-${linkLocale}`}
      title={title}
    >
      {LOCALE_NAMES[linkLocale]}
    </PageFooterLocaleLinksDisabledText>
  );
}
